<template>
  <div class="no-active-campaign">
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          Ч
        </div>
      </div>
      <div class="info-box-content">
        честита
      </div>
    </div>
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          Н
        </div>
      </div>
      <div class="info-box-content">
        нова {{newYear}}
      </div>
    </div>
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          Г
        </div>
      </div>
      <div class="info-box-content">
        година
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newYear31st-slogan-component",
  data() {
    return {
      newYear: 2020,
    }
  },
  beforeMount() {
    const now = new Date();
    if (now.getMonth() === 0) {
      this.newYear = now.getFullYear();
    } else {
      this.newYear = now.getFullYear() + 1;
    }
  }
}
</script>

<style scoped>
.info-box {
  width: 300px;
}

.info-box-title {
  flex-basis: 120px;
  height: 80px;
  font-size: 1rem;
}

.info-box-content {
  align-self: center;
}
</style>
